import React from "react";
import "../Styles/MediaDisplay.css"
import logo from "../../../../../assets/images/grid-layout.png"

const GridLayout = () => {
  return (
    <div>
      <div className="media-display-layout">
        {logo && <img src={logo} alt="Logo" className="st-profile-logo"style={{width: "100%", height: "100%"}}/>}
      </div>
          <div className="grid-layout" style={{color: "darkgray"}}>🖼️ Grid Layout View</div>
    </div>
  );
};

export default GridLayout;
